import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identify the Edge",
    opening: localizedGenderNode(
      [
      "Today I notice when the thought runs to the edge.",
      "I pause with myself.",
      "One breath."
    ],
      [
      "Today I notice when the thought runs to the edge.",
      "I pause with myself.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which thought jumps straight to the edge?",
      "What is the worst thing I imagine?",
      "What do I feel in my body when it rises?"
    ],
      [
      "Which thought jumps straight to the edge?",
      "What is the worst thing I imagine?",
      "What do I feel in my body when it rises?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An extreme thought is a thought, not reality."
    ],
      [
      "An extreme thought is a thought, not reality."
    ]
    ),
    action: localizedGenderNode(
      "one breath and a line in my heart - I am here.",
      "one breath and a line in my heart - I am here."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Trigger",
    opening: localizedGenderNode(
      [
      "Today I identify what activates the catastrophe.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I identify what activates the catastrophe.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does it rise the fastest?",
      "Which trigger repeats again and again?",
      "What am I trying to protect?"
    ],
      [
      "When does it rise the fastest?",
      "Which trigger repeats again and again?",
      "What am I trying to protect?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Sometimes the mind intensifies to feel in control."
    ],
      [
      "Sometimes the mind intensifies to feel in control."
    ]
    ),
    action: localizedGenderNode(
      "I name one trigger.",
      "I name one trigger."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Fact Versus Story",
    opening: localizedGenderNode(
      [
      "Today I separate fact from imagination.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I separate fact from imagination.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the single fact I have right now?",
      "What story gets placed on it?",
      "What do I still not know?"
    ],
      [
      "What is the single fact I have right now?",
      "What story gets placed on it?",
      "What do I still not know?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Uncertainty feels dangerous, but it is not necessarily danger."
    ],
      [
      "Uncertainty feels dangerous, but it is not necessarily danger."
    ]
    ),
    action: localizedGenderNode(
      "a line in my heart - it is not certain, and I am here.",
      "a line in my heart - it is not certain, and I am here."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Slow the Film",
    opening: localizedGenderNode(
      [
      "Today I slow the film.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I slow the film.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "At what point does the film become extreme?",
      "What image keeps repeating?",
      "What do I need in this moment?"
    ],
      [
      "At what point does the film become extreme?",
      "What image keeps repeating?",
      "What do I need in this moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I slow down, I have space to breathe."
    ],
      [
      "When I slow down, I have space to breathe."
    ]
    ),
    action: localizedGenderNode(
      "I pause for five seconds before I continue thinking.",
      "I pause for five seconds before I continue thinking."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Repeating Pattern",
    opening: localizedGenderNode(
      [
      "Today I identify a steady pattern.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I identify a steady pattern.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which topic repeats the most?",
      "What time of day does it rise?",
      "What do I do right after?"
    ],
      [
      "Which topic repeats the most?",
      "What time of day does it rise?",
      "What do I do right after?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A familiar pattern helps me see it is repeating, not new."
    ],
      [
      "A familiar pattern helps me see it is repeating, not new."
    ]
    ),
    action: localizedGenderNode(
      "I mark for myself - this is my pattern.",
      "I mark for myself - this is my pattern."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Body Signal",
    opening: localizedGenderNode(
      [
      "Today I notice the first body signal.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I notice the first body signal.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where in the body does it start?",
      "What changes in the breath?",
      "What do I want to do when it arrives?"
    ],
      [
      "Where in the body does it start?",
      "What changes in the breath?",
      "What do I want to do when it arrives?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The body signals earlier than the thought."
    ],
      [
      "The body signals earlier than the thought."
    ]
    ),
    action: localizedGenderNode(
      "one hand on the chest, one breath.",
      "one hand on the chest, one breath."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "An Inner Boundary",
    opening: localizedGenderNode(
      [
      "Today I create an inner boundary for the thought.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I create an inner boundary for the thought.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does the thought already cross a boundary?",
      "Which inner sentence intensifies it?",
      "What do I want to say to myself instead?"
    ],
      [
      "When does the thought already cross a boundary?",
      "Which inner sentence intensifies it?",
      "What do I want to say to myself instead?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner boundary does not erase a thought, it softens it."
    ],
      [
      "An inner boundary does not erase a thought, it softens it."
    ]
    ),
    action: localizedGenderNode(
      "I say one boundary sentence to myself.",
      "I say one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Gentle Check",
    opening: localizedGenderNode(
      [
      "Today I choose a gentle check.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I choose a gentle check.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I know for sure right now?",
      "What am I assuming without checking?",
      "What can I set aside for now?"
    ],
      [
      "What do I know for sure right now?",
      "What am I assuming without checking?",
      "What can I set aside for now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small accuracy lowers a big drama."
    ],
      [
      "A small accuracy lowers a big drama."
    ]
    ),
    action: localizedGenderNode(
      "I write one line of fact.",
      "I write one line of fact."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "A Soft Relation to the Thought",
    opening: localizedGenderNode(
      [
      "Today I meet my mind without a fight.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I meet my mind without a fight.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my mind trying to do for me?",
      "What is it afraid will happen?",
      "How does it feel when I am gentle with it?"
    ],
      [
      "What is my mind trying to do for me?",
      "What is it afraid will happen?",
      "How does it feel when I am gentle with it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even an extreme thought is a try to protect."
    ],
      [
      "Even an extreme thought is a try to protect."
    ]
    ),
    action: localizedGenderNode(
      "a line in my heart - thank you for the warning, I am breathing.",
      "a line in my heart - thank you for the warning, I am breathing."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Need Under the Fear",
    opening: localizedGenderNode(
      [
      "Today I name a need under the fear.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I name a need under the fear.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What need sits under the thought?",
      "What would calm me a little?",
      "What am I asking of myself?"
    ],
      [
      "What need sits under the thought?",
      "What would calm me a little?",
      "What am I asking of myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I identify a need, I have direction."
    ],
      [
      "When I identify a need, I have direction."
    ]
    ),
    action: localizedGenderNode(
      "I write one need in a sentence.",
      "I write one need in a sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Request of Myself",
    opening: localizedGenderNode(
      [
      "Today I ask a small request of myself.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I ask a small request of myself.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which small request is possible for me?",
      "What would be a small sign it works?",
      "What might get in the way?"
    ],
      [
      "Which small request is possible for me?",
      "What would be a small sign it works?",
      "What might get in the way?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small request is not a solution, it is a start."
    ],
      [
      "A small request is not a solution, it is a start."
    ]
    ),
    action: localizedGenderNode(
      "I say the request to myself quietly.",
      "I say the request to myself quietly."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "A 5% Shift",
    opening: localizedGenderNode(
      [
      "Today I choose a small change in my thinking habit.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I choose a small change in my thinking habit.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is one habit I can change by five percent?",
      "When is it easiest for me to try?",
      "What would be a first step?"
    ],
      [
      "What is one habit I can change by five percent?",
      "When is it easiest for me to try?",
      "What would be a first step?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small change creates a new path."
    ],
      [
      "A small change creates a new path."
    ]
    ),
    action: localizedGenderNode(
      "I mark one first step.",
      "I mark one first step."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Anchor",
    opening: localizedGenderNode(
      [
      "Today I build a small anchor for a hard day.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I build a small anchor for a hard day.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which sentence holds me?",
      "Which place in my body feels safe?",
      "What helps me return to this moment?"
    ],
      [
      "Which sentence holds me?",
      "Which place in my body feels safe?",
      "What helps me return to this moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small anchor reminds me I do not have to run with the thought."
    ],
      [
      "A small anchor reminds me I do not have to run with the thought."
    ]
    ),
    action: localizedGenderNode(
      "I choose one anchor and remind myself of it.",
      "I choose one anchor and remind myself of it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "A Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I close gently.",
      "I pause.",
      "One breath."
    ],
      [
      "Today I close gently.",
      "I pause.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about my catastrophic thoughts?",
      "What is the earliest sign?",
      "Which sentence brings me back to the moment before?"
    ],
      [
      "What did I learn about my catastrophic thoughts?",
      "What is the earliest sign?",
      "Which sentence brings me back to the moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can be with a thought and choose a response."
    ],
      [
      "I can be with a thought and choose a response."
    ]
    ),
    action: localizedGenderNode(
      "closing line - I pause, I breathe, and I choose the moment before response.",
      "closing line - I pause, I breathe, and I choose the moment before response."
    ),
  },
].map(buildNormalizedDay);

export const catastrophicThoughtsBlueprintEn = buildNormalizedPilotBlueprint({
  id: "catastrophic_thoughts_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "catastrophic_thoughts",
  category: "general",
  journeyName: {
    he: "מחשבות קטסטרופליות",
    en: "Catastrophic Thoughts",
    es: "Pensamientos catastroficos",
  },
  days,
});

export default catastrophicThoughtsBlueprintEn;
